
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { CustomerGroup as CustomerGroupEnum } from '@/enums/CustomerGroup';
import { Venue } from '@/interfaces/models/Venue';

@Component
export default class ReleasesFilter extends Vue {
  @Prop({ type: Array, required: true }) public customerGroups!: CustomerGroupEnum[];
  @Prop({ type: Object, required: false }) public venue!: Venue;

  public selectedCustomerGroup: string = '';

  public mounted() {
    if (!this.venue) {
      this.$startLoading('venue');
    } else {
      this.setDefaultCustomerGroup();
    }
  }

  public setDefaultCustomerGroup() {
    if (this.venue.customerGroup) {
      this.selectedCustomerGroup = this.venue.customerGroup || '';
    }
  }

  @Watch('venue')
  public async onVenueChange() {
    if (this.venue && this.venue._id) {
      this.setDefaultCustomerGroup();
    }
  }

  @Watch('selectedCustomerGroup')
  public onFilterChange() {
    const customerGroup = this.selectedCustomerGroup;

    if (!customerGroup) {
      return this.setDefaultCustomerGroup();
    }

    this.$emit('filter', { customerGroup });
  }
}
